<template>
  <div class="wrapper">
    <!-- header -->
    <search-header @on-focus="trashAndSearch" />
    <!-- items -->
    <search-result
      v-if="isComplated || showSearchResult"
      class="searchResult"
      :tag-name="tagName"
    />
    <suggest v-else :suggests="suggests" @search-by-suggest="search" />
  </div>
</template>
<script>
import SearchHeader from '@/components/header/SearchHeader'
import Suggest from '@/components/search/Suggest'
import SearchResult from '@/components/search/SearchResult'
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  components: {
    Suggest,
    SearchHeader,
    SearchResult,
  },
  data() {
    return {
      isComplated: false,
      suggests: [],
      tagName: '',
    }
  },
  computed: {
    ...mapGetters({
      shopId: 'seat/getShopId',
      getSuggestsByKeyword: 'search/getSuggestsByKeyword',
      searchKeyword: 'search/getSearchKeyword',
      suggestsList: 'search/getSuggests',
      lastSearchedTagName: 'search/getTagName',
      showSearchResult: 'search/isShowSearchResult',
      getItemByItemCode: 'menu/getItemByItemCode',
      language: 'setting/getLanguage',
    }),
  },
  watch: {
    /**
     * 検索語句が変更されるたびに対応する検索タグを取得する
     */
    searchKeyword(newSearchKeyword) {
      this.getSuggests(newSearchKeyword)
    },
    isComplated() {
      this.suggests = []
    },
    language() {
      this.$emit('updateHead')
    },
    shopId() {
      this.fetchSuggests()
    },
  },
  created() {
    if (this.shopId) {
      this.fetchSuggests()
    }
    // 検索から商品詳細に遷移し、検索に戻ってきた場合は検索結果を表示する
    if (this.showSearchResult) {
      this.tagName = this.lastSearchedTagName
      this.search(this.lastSearchedTagName)
    } else {
      // メニューから検索ページに来た場合はストアに保存しているキーワードを初期化する
      this.updateSearchKeyword('')
    }
  },
  methods: {
    ...mapMutations({
      setShowSearchResult: 'search/setShowSearchResult',
      updateSearchKeyword: 'search/setSearchKeyword',
      setTagName: 'search/setTagName',
    }),
    ...mapActions({
      fetchSuggests: 'search/fetchSuggests',
    }),
    // 候補となるタグをストアから取得する
    getSuggests(text) {
      this.setShowSearchResult(false)
      this.isComplated = false
      if (text === '') {
        this.suggests = []
        return
      }
      const suggests = this.getSuggestsByKeyword(text)
      if (suggests.length === 0) {
        this.suggests = []
        return // 一致するタグがなければなにもしない
      }
      this.suggests = suggests.map((suggest) => Object.keys(suggest)[0])
    },
    search(tagName) {
      this.$nextTick(() => {
        this.setTagName(tagName)
        this.isComplated = true
        this.tagName = tagName
      })
    },
    trashAndSearch() {
      this.isComplated = false
      this.getSuggests(this.searchKeyword)
    },
  },
  head: {
    title() {
      return {
        inner: this.$t(`pageTitle.${this.$route.name}`),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  background-color: #fff;
}
</style>
